
<div class="header-container">
  <div class="column1">
  <app-global-search></app-global-search>
  <a [routerLink]="mainPath"  class="logo mt32" >
    <svg [icon]="icons.Logo" class="impaired-size-56 icon-logo"/>
    <div class="logo-title">
      <span class="button1-impaired-text">{{ 'LAYOUT.PORTALNAME' | translate }}</span>
      <p class="body1-impaired">{{ 'LAYOUT.GOVERMENT' | translate }}</p>
    </div>
  </a>
  </div>
  <div class="column2">
  <div class="button-block-container">
    <button (click)="changeLanguage($event)"  class="button2-impaired">
      {{ 'LAYOUT.LANGUAGE' | translate }}
    </button>

    <button [routerLink]="'/'" class="button2-impaired">
      {{ 'VERSION_VISUALLY_IMPAIRED.NORMAL_VERSION' | translate }}
    </button>

    <app-button-icon cdkOverlayOrigin #settingsTrigger="cdkOverlayOrigin" [buttonName]="'VERSION_VISUALLY_IMPAIRED.SETTINGS' | translate" (clickOnButton)="isOpenSettings = !isOpenSettings" ></app-button-icon>
  </div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayPositions]="settingsOverlayPosition"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayOrigin]="settingsTrigger"
    [cdkConnectedOverlayOpen]="isOpenSettings"
    (backdropClick)="closeSettings()"
    [cdkConnectedOverlayPanelClass]="'cdk-version-for-visually-impaired'"
  >
    <app-setting-styles (settingClose)="isOpenSettings = !isOpenSettings"></app-setting-styles>
  </ng-template>

  <div class="link-block-container mt32">

    <a class="link-block" href="http://mos.ru" target="_blank">
      <svg [icon]="icons.LogoMosRu" class="mos-ru-icon"/>
    </a>

<!--    <a class="link-block" href="http://mos.ru" target="_blank">
      <div class="link3-impaired">
        {{ 'VERSION_VISUALLY_IMPAIRED.INFORMATION_CITY' | translate }}
      </div>
      <div class="body3-impaired">mos.ru</div>
    </a>
    <a class="link-block" href="https://www.mos.ru/dit/" target="_blank">
      <div class="link3-impaired">
        {{ 'VERSION_VISUALLY_IMPAIRED.MOSCOV_GOVERNMENT' | translate }}
      </div>
      <div class="body3-impaired">dit.mos.ru</div>
    </a>
    <a class="link-block" href="https://gorod.mos.ru/" target="_blank">
      <div class="link3-impaired">
        {{ 'VERSION_VISUALLY_IMPAIRED.OUR_TOWN' | translate }}
      </div>
      <div class="body3-impaired">gorod.mos.ru</div>
    </a>
    <a class="link-block" href="https://video.dit.mos.ru/" target="_blank">
      <div class="link3-impaired">
        {{ 'VERSION_VISUALLY_IMPAIRED.CCTV' | translate }}
      </div>
      <div class="body3-impaired">video.dit.mos.ru</div>
    </a>
    <a class="link-block" href="https://investmoscow.ru/" target="_blank">
      <div class="link3-impaired">
        {{ 'VERSION_VISUALLY_IMPAIRED.MOSCOW_INVEST_PORTAL' | translate }}
      </div>
      <div class="body3-impaired">investmoscow.ru</div>
    </a>-->
  </div>
</div>
</div>
